<template>
    <div>
        <a-steps
            :current="currentStep"
        >
            <a-step v-for="step in steps" :key="step.title" :title="step.title" />
        </a-steps>
        <div class="steps-content"
            v-if="currentStep === 0"
        >
            <div class="steps-main">
                <FileUploadDropzone 
                    v-model="fileList"
                />
            </div>
            <a-divider></a-divider>
            <div class="steps-actions">
                <a-button
                    :disabled="fileList.length < 1"
                    v-on:click="stepForward"
                >
                    Tovább
                    <a-icon type="right" />
                </a-button>
            </div>       
        </div>

        <div class="steps-content"
            v-if="currentStep === 1"
        >
            <div class="steps-main">
                <div   class="card-grid"
                >   

                    <MaskedSlideTransition 
                        v-for="(fileObj, ix) in fileList"
                        :key="fileObj.uid"
                        class="card-transition-scale-item"
                    >
                        <FileCardComponent
                            class="card-transition-scale-item"
                            
                            :fileIndex="ix"
                            :fileObj="fileObj"

                            v-on:fileObjChange="fileObjChangeHandler"
                            v-on:removeFile="removeFileByIndex"
                        />
                    </MaskedSlideTransition>
                    <!-- <a-row
                        class="user-cards-row"
                        v-for="(row, ix) in filesGrid"
                        :gutter="26"
                        :key="ix"
                        
                    >
                        <a-col 
                            v-for="(fileObj, jx) in row"
                            :key="fileObj.uid"
                            :xs="24"
                            :md="24 / row.length"
                            :style="{
                                marginTop: '10px',
                                marginBottom: '10px'
                            }"
                        >
                            <FileCardComponent
                                :key="fileObj.uid"
                                :fileIndex="ix + jx"
                                :fileObj="fileObj"

                                v-on:fileObjChange="fileObjChangeHandler"
                                v-on:removeFile="removeFileByIndex"
                            />
                        </a-col>
                    </a-row> -->
                </div>
                
            </div>
            <a-divider></a-divider>
            <div class="steps-actions">
                <a-button
                    v-on:click="stepBackward"
                >   
                    <a-icon type="left" />
                    Vissza
                </a-button>
                <a-button
                    :disabled="fileList.length < 1"
                    v-on:click="uploadAll"
                >
                    <a-icon type="upload" />
                    Fájlok feltöltése
                    <a-icon type="right" />
                </a-button>
            </div>
        </div>

        <div class="steps-content"
            v-if="currentStep === 2"
        >   
            <div
                :style="{
                    margin: 'auto'
                }"
            >
                <a-button v-on:click="backToInfo" icon="file">Vissza az Info-hoz</a-button>
            </div>
            <div
                v-if="this.uploadingFiles"
            >
                <FileUploadProgressList :folderId="this.folderId" />
            </div>
        </div>

        
    </div>
    
</template>

<script>
import axios from 'axios';
import FileUploadProgressList from './FileUploadProgressList.vue';
import FileUploadDropzone from './FileUploadDropzone.vue';
import FileCardComponent from './FileCardComponent.vue';

import MaskedSlideTransition from '@/transitions/MaskedSlideTransition.vue';
import { UPDATE_UPLOAD_PROGRESS, ADD_UPLOADING_FILE } from '../../../store/mutation_types';
import { fileUpload } from '../../../http/api';

export default {
    components: {
        FileUploadProgressList,
        FileUploadDropzone,
        FileCardComponent,
        MaskedSlideTransition
    },

    props: {
        folderId: {
            type: String | Number,
            default: ''

        },
        folderUuid: {
            type: String | Number,
            default: ''
        }
    },

    data() {
        return {
            cols: 3,

            currentStep: 0,
            steps: [
                {
                    title: 'Fájlok kiválasztása',
                    icon: 'inbox'
                },
                {
                    title: 'Fájlok szerkesztése',
                    icon: 'hdd'
                },
                {
                    title: 'Feltöltési folyamat',
                    icon: 'upload'
                }
            ],

            fileList: [],

            formError: true
        }
    },

    computed: {
        uploadingFiles() {        
            return this.$store.getters.getUploadingFiles(this.folderId);
        },

        filesGrid() {
            const fileListLength = this.fileList.length;
            let rows = Math.round(fileListLength / this.cols);
            if (rows < 1) {
                rows = 1;
            }
            let grid = [];
            
            for (let i = 0; i < rows; i++) {
                let row = [];
                for (let j = 0; j < this.cols; j++) {
                    let idx = i * this.cols + j;
                    if (this.fileList[idx]) {
                        row.push(this.fileList[idx])
                    }
                }
                grid.push(row);
            }
            return grid;
        }

        // fileListWithForm() {
        //     return this.fileList.map(file => {
        //         return {

        //         }
        //     })
        // }
    },

    methods: {
        stepForward() {
            this.currentStep += 1;
        },

        stepBackward() {
            this.currentStep -= 1;
        },

        backToInfo() {
            this.$router.push({
                name: 'folder',
                params: {
                    id: this.$route.params.id
                }
            })
        },
        
        handleProgressChange(progress, fileId) {
            console.log('id: ', fileId,  ' prog:', progress);
            let progressPercent = Math.round((progress.loaded * 100) / progress.total);
            
            this.$store.commit({
                type: UPDATE_UPLOAD_PROGRESS,
                uid: fileId,
                progress: progressPercent,
                status: 'active'
            })
        },

        // fileFormChange(data) {
        //     let newFileList = [...this.fileList];

        //     for (let key in data.values) {
        //         newFileList[data.ix][key] = data.values[key];
        //     }
            
        //     this.fileList = newFileList;
        // },

        fileObjChangeHandler(data) {
            let newFileList = [...this.fileList];

            for (let key in data.changedValues) {
                newFileList[data.ix][key] = data.changedValues[key];
            }

            this.fileList = newFileList;
        },

        removeFileByIndex(fileIndex) {
            console.log('REMOVING: ', fileIndex)
            let newFileList = [...this.fileList];
            newFileList.splice(fileIndex, 1);
            this.fileList = newFileList;
            // if (this.fileList.length < 1) {
            //     this.currentStep = 0;
            // }
            console.log('AFTERREMOVE: ', this.fileList)
        },

        removeFileById(fileId) {
            let newFileList = [...this.fileList];
            let toRemoveIx = newFileList.findIndex(file => file.uid === fileId);
            newFileList.splice(toRemoveIx, 1);
            this.fileList = newFileList;
        },

        uploadAll() {
            this.stepForward();
            this.fileList.forEach((file, fileIndex) => {
                this.fileUpload(file, fileIndex)
            })
        },

        fileUpload(file, fileIndex) {
            console.log('UPPPFILE', file);
            let formData = new FormData();
            formData.append('file', file.originFileObj);
            formData.append('nice_name', file.nice_name);
            formData.append('description', '');

            const config = {
                onUploadProgress: (progress) => this.handleProgressChange(progress, file.uid)
            };
            let uploadingFile = {
                nice_name: file.nice_name,
                progress: 0,
                status: 'active',
                uid: file.uid,
                folderId: this.folderId
            };

            this.$store.commit({
                type: ADD_UPLOADING_FILE,
                newFile: uploadingFile
            })
            fileUpload(formData, this.$route.params.id, config)
            .then(res => {
                console.log('REZ: ', res);
                this.$store.commit({
                    type: UPDATE_UPLOAD_PROGRESS,
                    uid: file.uid,
                    progress: 100,
                    status: 'success'
                })
                this.removeFileById(file.uid);
            }).catch(err => {
                console.log('ERR', err);
                this.$store.commit({
                    type: UPDATE_UPLOAD_PROGRESS,
                    uid: file.uid,
                    status: 'exception'
                })
            })


        }
    }
}
</script>

<style lang="scss" scoped>
    .steps-content {
        margin-top: 25px;
        
    }
    .steps-main {
        min-height: 300px;
    }

    .card-grid {
        display: grid;

        grid-template-columns: 1fr;
        grid-gap: 15px;

        @include sm {
            grid-template-columns: 1fr 1fr 
        }

        @include lg {
            grid-template-columns: 1fr 1fr 1fr
        }


    }

    .card-transition-scale-item {
        transition: all 450ms;
    }

    .card-transition-scale-enter, .card-transition-scale-leave-to {
        opacity: 0;
        transform: scale(0.7);
        max-width: 250px;
        max-height: 200px;
    }
</style>
